export default {
    "FETCH_QUESTION": "FETCH_QUESTION",
    "QUESTION_OPENED": "QUESTION_OPENED",
    "QUESTION_CLOSED": "QUESTION_CLOSED"
}